module.exports = __webpack_public_path__ + "img/img_logo_vivo.fe9a1c61.svg";